import React from 'react'
import { Row, Col } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import { FormLabels } from 'src/components'
import styles from './CustomPanelHeader.module.scss'

interface PropsType {
  title: string
  subtitle: string
}

const CustomPanelHeader: React.FC<PropsType> = ({ title, subtitle }) => {

  return (
    <Row className={styles['row']}>
      <Col xs={4} lg={1}>
        <CheckOutlined className={styles['icon']} />
      </Col>
      <Col xs={20} lg={23}>
        <FormLabels
          title={title}
          subtitle={subtitle}
        />
      </Col>
    </Row>
  )
}

export default CustomPanelHeader
